
const digest = '107f31277dd7d40eb16338ccf75afcbc9965baf41f46fb48263846cd72f546fc';
const classes = {"wrapper":"_wrapper_b7icd_1","filterWrapper":"_filterWrapper_b7icd_10","contentWrapper":"_contentWrapper_b7icd_15","loadingWrapper":"_loadingWrapper_b7icd_18","controls":"_controls_b7icd_22","subcontrols":"_subcontrols_b7icd_29","content":"_content_b7icd_15","paginator":"_paginator_b7icd_37"};
const css = `._wrapper_b7icd_1 {
  display: flex;
  flex-direction: row;
  font-family: Rubik, "sans-serif";
  flex-grow: 1;
  height: 100%;
  border: 1px solid #eaedf3;
  background-color: #ffffff;
}
._wrapper_b7icd_1 ._filterWrapper_b7icd_10 {
  display: flex;
  flex-direction: column;
  position: relative;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 {
  flex: 1;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 ._loadingWrapper_b7icd_18 {
  height: 100%;
  padding: 12px;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 ._controls_b7icd_22 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 ._controls_b7icd_22 ._subcontrols_b7icd_29 {
  display: flex;
  justify-content: space-between;
  gap: 15px;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 ._content_b7icd_15 {
  flex: 1;
}
._wrapper_b7icd_1 ._contentWrapper_b7icd_15 ._content_b7icd_15 ._paginator_b7icd_37 {
  border-bottom: 1px solid #e2e5ed;
  padding: 12px;
  gap: 15px;
  display: flex;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  